import classNames from "classnames";

const classes = {
    slideContainer: (props, type) => classNames({
        'slide': true,
        [type]: true,
        'active': props.active,
        'deactivating': props.deactivating
    }),
    slideDuration: props => classNames({
        'duration': props.duration !== null,
        'active': props.active
    })
};

export default classes;


// WEBPACK FOOTER //
// ./src/components/common/classes.js